// extracted by mini-css-extract-plugin
module.exports = {"create-orga-btn":"sidebar_create-orga-btn__hLpn9","menu-orga":"sidebar_menu-orga__VaHaY"};